import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { useSelector } from "react-redux";
import { selectCandidateCv } from "../../../modules/createJob/slice/candidateSlice";
import { Toolbar } from "./Toolbar";
import { Warning } from "../Warning/Warning";
import { useEffect } from "react";
import { analytics } from "../../utils/analytics";
import { logEvent } from "firebase/analytics";
import './cvViewer.scss'
import "@cyntler/react-doc-viewer/dist/index.css";

export function CVViewer({ docViewerRef }: { docViewerRef: any }) {
    const candidateCv = useSelector(selectCandidateCv)
    useEffect(() => {
        logEvent(analytics, 'Cv screen');
    }, [])
    const docs = [
        {
            uri: candidateCv,
            fileType: candidateCv.split('.').pop()
        }
    ];

    return (
        <>
            {candidateCv ? (
                <DocViewer
                    language="en"
                    ref={docViewerRef}
                    documents={docs}
                    pluginRenderers={DocViewerRenderers}
                    theme={{
                        disableThemeScrollbar: true,
                    }}
                    config={{
                        header: {
                            overrideComponent: Toolbar,
                        },
                        pdfZoom: {
                            defaultZoom: 1.1,
                            zoomJump: 0.2,
                        },
                        pdfVerticalScrollByDefault: true,
                    }}
                    style={candidateCv?.split('.')?.pop() === 'docx' ? {
                        transform: window.innerWidth <= 1024 ? 'scale(0.5)' : 'none', // Apply zoom out on small and medium screens
                        transformOrigin: window.innerWidth <= 1024 ? 'top left' : 'initial', // Set origin for scaling on small and medium screens
                        width: window.innerWidth <= 1024 ? '200%' : '100%', // Adjust width for scaling on small and medium screens
                        height: window.innerWidth <= 768 ? '100vh' : '150vh', // Adjust height for scaling on small and medium screens
                    } : {}}
                />
            ) : (
                <Warning title="Something went wrong" message="Failed loading documents, please refresh" />
            )}
        </>
    )
}